var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircularFilledIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.64844 12.8906C2.64844 14.8684 3.23493 16.8018 4.33374 18.4463C5.43256 20.0908 6.99434 21.3725 8.8216 22.1294C10.6489 22.8863 12.6595 23.0843 14.5993 22.6985C16.5391 22.3126 18.321 21.3602 19.7195 19.9617C21.118 18.5632 22.0704 16.7813 22.4563 14.8415C22.8421 12.9017 22.6441 10.8911 21.8872 9.06379C21.1304 7.23653 19.8486 5.67474 18.2041 4.57593C16.5596 3.47711 14.6262 2.89062 12.6484 2.89062C9.99658 2.89162 7.45362 3.9455 5.57847 5.82065C3.70332 7.6958 2.64943 10.2388 2.64844 12.8906ZM16.148 12.8906L11.6482 17.3905L10.2419 15.9702L13.3215 12.8906L10.2419 9.81009L11.6482 8.38983L16.148 12.8906Z",
    fill: "#66FFE0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularFilledIcon);
export default __webpack_public_path__ + "static/media/circular-filled-icon.dca5142c778c025a5e7cd7b621000830.svg";
export { ForwardRef as ReactComponent };